(function($) {
    $('.Modal').on('offcanvas-open', function() {
        $('body').addClass('is-Offcanvas--modal_open');
    });
    $('.Modal').on('offcanvas-dismiss', function() {
        $('body').removeClass('is-Offcanvas--modal_open');
    });
}(jQuery));
